/**
 * Derive the opportunity type from a package's `typeOptions` array.
 *
 * Mirrors the same logic in Needle's `opportunityTypeUtils.ts`:
 * - Backend enum form ("FLASH_SALE") and display-name form ("Flash Sale") are both accepted.
 * - The derived type is the FIRST item in `typeOptions` (i.e. the package default).
 * - Falls back to `'UPSIZE'` when `typeOptions` is absent/empty (appropriate for the
 *   upsize wizard context where UPSIZE is the intent if no constraint is declared).
 *
 * This is the single source of truth used by both UpsizeCard (at pick-time) and
 * wizardMappers (at submit time), so packageTier and opportunityType are always
 * set from the same derivation.
 */
export function deriveTypeFromPackage(typeOptions: string[] | undefined | null): 'UPSIZE' | 'FLASH_SALE' {
  if (!typeOptions || typeOptions.length === 0) return 'UPSIZE';

  const first = typeOptions[0];
  if (first === 'FLASH_SALE' || first === 'Flash Sale') return 'FLASH_SALE';
  if (first === 'UPSIZE' || first === 'Upsize') return 'UPSIZE';

  return 'UPSIZE';
}
